import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { ChangeEvent, useContext, useEffect, useId, useState } from 'react';

import { LocaleContext } from '@/Contexts/LocaleContext';
import { EventProps } from '@/models/Event';
import { EventSubTypeProps } from '@/models/EventSubType';
import { QuestionProps } from '@/models/Question';

import CharacterCount from './CharacterCount';
import { CurrentApplicationContext } from '@/Contexts/CurrentApplicationContext';

type EventSubTypePropsLocal = {
  eventInfo: EventProps | null;
  question: QuestionProps;
  subTypes: EventSubTypeProps[] | null;
  onEventChange: (updatedEvent: EventProps) => void;
};

export default function EventSubType({
  eventInfo,
  question,
  subTypes,
  onEventChange,
}: EventSubTypePropsLocal) {
  const { localeLanguageCode, translatedText } = useContext(LocaleContext);
  const { canEdit } = useContext(CurrentApplicationContext);
  const eventSubTypeMaxTextLength = 4000;
  const [eventSubTypeDescription, setEventSubTypeDescription] = useState<string | null>(null);

  useEffect(() => {
    if (eventInfo != null) {
      setEventSubTypeDescription(eventInfo.eventSubTypeOther ?? null);
    }
  }, [eventInfo]);

  const inputChanged = (value: string) => {
    if (eventInfo == null) return;

    onEventChange({
      ...eventInfo,
      eventSubTypeOther: value,
    });
  };

  const labelId = useId();

  return (
    <>
      <FormControl fullWidth disabled={!canEdit} required={question?.questionNeeded}>
        <InputLabel id={labelId}>
          {[2333].includes(question?.id) && localeLanguageCode != null
            ? `${question?.eventType?.nameTranslations[localeLanguageCode]} ${translatedText?.event?.type}`
            : translatedText?.event?.labelSubType}
        </InputLabel>
        <Select
          labelId={labelId}
          id={`${labelId}-select`}
          value={
            eventInfo?.eventSubTypeId != null && subTypes != null && subTypes?.length > 0
              ? eventInfo?.eventSubTypeId
              : ''
          }
          label={translatedText?.event?.labelSubType}
          onChange={(e) =>
            onEventChange({
              ...eventInfo,
              eventSubTypeId: e.target.value,
            })
          }
        >
          {subTypes?.map((x: EventSubTypeProps) => {
            return (
              <MenuItem key={x.id} value={x.id}>
                {x.nameTranslations[localeLanguageCode != null ? localeLanguageCode : 'en']}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>

      {subTypes != null &&
        eventInfo?.eventSubTypeId ==
          subTypes?.find((x) =>
            ['Other', 'Autre', 'Otro', 'Outro'].includes(
              x.nameTranslations[localeLanguageCode != null ? localeLanguageCode : 'en']
            )
          )?.id && (
          <Box>
            <TextField
              fullWidth
              label={translatedText?.event?.labelSubTypeOther}
              multiline
              disabled={!canEdit}
              minRows={4}
              value={eventSubTypeDescription ?? ''}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                setEventSubTypeDescription(e.target.value);
                inputChanged(e.target.value);
              }}
              slotProps={{
                htmlInput: { maxLength: eventSubTypeMaxTextLength },
              }}
            />
            <CharacterCount
              text={eventSubTypeDescription}
              max={eventSubTypeMaxTextLength}
              visible={canEdit}
            />
          </Box>
        )}
    </>
  );
}
